import { useState } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { EjercicioState, setEjercicio } from '../../store/slices/ejercicio';
import CrearEjercicio from './CrearEjercicio';
import EditarEjercicio from './EditarEjercicio';
import EliminarEjercicio from './EliminarEjercicio';
import FormularioAntiderivadaEdicion from './Formularios/FormularioAntiderivadaEdicion';
// componentes propios
import FormularioEcuacionEdicion from './Formularios/FormularioEcuacionEdicion';
import FormularioFormulaEdicion from './Formularios/FormularioFormulaEdicion';
import FormularioIntervaloEdicion from './Formularios/FormularioIntervaloEdicion';
import FormularioNumeroEdicion from './Formularios/FormularioNumeroEdicion';
import FormularioPuntoEdicion from './Formularios/FormularioPuntoEdicion';
import FormularioSMEdicion from './Formularios/FormularioSMEdicion';
import FormularioVectorEdicion from './Formularios/FormularioVectorEdicion';
import MenuCrearEjercicio from './MenuCrearEjercicio';

const Ejercicios = () => {

  const dispatch = useDispatch<AppDispatch>();

  const { ejercicios, isLoading } = useSelector((state: RootState) => state.ejercicio);

  // Crear Ejercicio
  const [openCrear, setOpenCrear] = useState(false);
  const [tipo, setTipo] = useState('');

  const handleClickOpenCrear = (tipo: string) => {
    setTipo(tipo)
    setOpenCrear(true);
  }

  // Eliminar Ejercicio
  const [openEliminar, setOpenEliminar] = useState(false);

  const handleEliminarEjercicio = (ejercicio: EjercicioState) => {
    dispatch(setEjercicio(ejercicio));
    setOpenEliminar(true)
  }

  // Editar Ejercicio
  const [openEditar, setOpenEditar] = useState(false);

  const handleEditarEjercicio = (ejercicio: EjercicioState) => {
    dispatch(setEjercicio(ejercicio));
    setOpenEditar(true)
  }

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <>

      {
        openCrear && <CrearEjercicio open={openCrear} setOpen={setOpenCrear} tipo={tipo} />
      }

      {
        openEliminar && <EliminarEjercicio open={openEliminar} setOpen={setOpenEliminar} />
      }

      {
        openEditar && <EditarEjercicio open={openEditar} setOpen={setOpenEditar} />
      }

      <div className="container mb-4">
        <div className="row justify-content-end align-items-center">
          <div className="col-auto px-1" >
            <MenuCrearEjercicio handleClickOpenCrear={handleClickOpenCrear} />
          </div>
          <div className="col-auto px-1">
            <span style={{ color: 'grey' }}>Crear Ejercicio</span>
          </div>
        </div>
      </div>

      {
        ejercicios.map((item, index) => {
          const { eid, tipo } = item;
          if (tipo === 'numerico') {
            return (
              <FormularioNumeroEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }

          if (tipo === 'intervalo') {
            return (
              <FormularioIntervaloEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }

          if (tipo === 'punto') {
            return (
              <FormularioPuntoEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }

          if (tipo === 'vector') {
            return (
              <FormularioVectorEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }

          if (tipo === 'formula') {
            return (
              <FormularioFormulaEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }

          if (tipo === 'ecuacionXY') {
            return (
              <FormularioEcuacionEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }

          if (tipo === 'antiderivada') {
            return (
              <FormularioAntiderivadaEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }


          if (tipo === 'seleccion-multiple') {
            return (
              <FormularioSMEdicion
                key={eid}
                index={index}
                ejercicio={item}
                handleEliminarEjercicio={handleEliminarEjercicio}
                handleEditarEjercicio={handleEditarEjercicio}
              />
            )
          }

          return (
            <div key={eid}>PENDIENTE</div>
          )
        })
      }
    </>
  )
}

export default Ejercicios;